var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaPlataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 1,
    y: 1,
    stroke: "#003049",
    strokeWidth: 2,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#003049",
    strokeWidth: 2,
    d: "M13 1v24m0-24v24M1 13h24M2.707 2.293l22 22m-23.414 0 22-22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaPlataIcon);
export default __webpack_public_path__ + "static/media/laPlataIcon.d234916ba9e6fcb8f0cc389c046d77d5.svg";
export { ForwardRef as ReactComponent };